import React from 'react';
import cn from 'classnames';
import EditableTextField from '../EditableTextField/EditableTextField';
import { FindingsStatus } from '../FindingsStatus/FindingsStatus';

interface PriorCardiacProceduresProps {
  editingReport: boolean;
  highlightKeyVesselRelatedFields?: boolean;
  text: string[];
  updateDraftText: (report: string) => void;
  draftText: string | undefined;
  autoFocus?: boolean;
  statusVersion?: boolean;
  onRevertFindings?: () => void;
}

export const PriorCardiacProceduresField: React.FunctionComponent<PriorCardiacProceduresProps> = ({
  editingReport,
  highlightKeyVesselRelatedFields,
  text,
  updateDraftText,
  draftText,
  autoFocus = false,
  statusVersion,
  onRevertFindings,
}) => {
  return (
    <div
      className={cn('report-field clinical-indication-field', {
        'report-field--highlighted': highlightKeyVesselRelatedFields,
      })}
    >
      {statusVersion !== undefined && <FindingsStatus versions={statusVersion} onRevertFindings={onRevertFindings} />}
      <div className="report-field__container">
        <h3 className="report-field__heading">Prior Cardiac Procedures</h3>
        <div className="report-field__field">
          <EditableTextField
            editMode={editingReport}
            text={text}
            updateDraftText={updateDraftText}
            draftText={draftText}
            autoFocus={autoFocus}
          />
        </div>
      </div>
    </div>
  );
};
